import { createSlice } from '@reduxjs/toolkit';
import { updateTagsApi } from '../../../rtk-apis/updateTags';

const updateTags = createSlice({
    name: 'updateTags',
    initialState: {
      studyTags: null,
      patientTags: null,
      seriesTags: null,
      loading: false,
      error: null,
      success: false,
    },
    reducers: {
      reset: (state) => {
        state.studyTags = null;
        state.patientTags = null;
        state.seriesTags = null;
        state.loading = false;
        state.error = null;
        state.success = false;
      },
    },
    extraReducers: (builder) => {
      // Study Tags
      builder
        .addCase(updateTagsApi.fetchStudyTags.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(updateTagsApi.fetchStudyTags.fulfilled, (state, action) => {
          state.studyTags = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(updateTagsApi.fetchStudyTags.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
  
      // Patient Tags
      builder
        .addCase(updateTagsApi.fetchPatientTags.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(updateTagsApi.fetchPatientTags.fulfilled, (state, action) => {
          state.patientTags = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(updateTagsApi.fetchPatientTags.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
  
      // Series Tags
      builder
        .addCase(updateTagsApi.fetchSeriesTags.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(updateTagsApi.fetchSeriesTags.fulfilled, (state, action) => {
          state.seriesTags = action.payload;
          state.loading = false;
          state.success = true;
        })
        .addCase(updateTagsApi.fetchSeriesTags.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.success = false;
        });
    },
  });
  
  export default updateTags.reducer;
  export const { reset } = updateTags.actions
